import { render, staticRenderFns } from "./HorizontalCustomizedTab.vue?vue&type=template&id=46b8d9ef&scoped=true"
import script from "./HorizontalCustomizedTab.vue?vue&type=script&lang=js"
export * from "./HorizontalCustomizedTab.vue?vue&type=script&lang=js"
import style0 from "./HorizontalCustomizedTab.vue?vue&type=style&index=0&id=46b8d9ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b8d9ef",
  null
  
)

export default component.exports